module.exports = __webpack_public_path__ + "f64d3a4cdcd90505940d34488c5d225c.jpg";